const cardsData = [
  {
    title: '让追剧成为一种生活方式',
    desc: '玫瑰视频不只是一个观看入口，更想成为你日常娱乐的一部分。下班路上刷一集轻喜剧，周末午后看一部高分电影——好的内容让生活更有温度。',
    img: 'https://readdy.ai/api/search-image?query=Cozy%20evening%20scene%20with%20warm%20lamp%20light%2C%20a%20tablet%20on%20a%20comfortable%20sofa%2C%20hot%20tea%20cup%2C%20soft%20blanket%2C%20rain%20outside%20window%2C%20relaxing%20home%20atmosphere%2C%20cinematic%20color%20grading&width=600&height=400&seq=cards-01&orientation=landscape',
  },
  {
    title: '比你更懂你的观影口味',
    desc: '基于你的观看记录自动推荐相似风格的影视内容，从古装到科幻、从悬疑到甜宠，找到真正适合你口味的好片好剧。',
    img: 'https://readdy.ai/api/search-image?query=Smart%20recommendation%20interface%20with%20floating%20movie%20poster%20cards%20arranged%20in%20a%20clean%20grid%2C%20warm%20minimalist%20UI%20design%2C%20soft%20ambient%20light%2C%20modern%20digital%20lifestyle%20aesthetic&width=600&height=400&seq=cards-02&orientation=landscape',
  },
  {
    title: '全网片源一个入口就够了',
    desc: '告别在多个APP之间来回切换的烦恼。红桃视频的热剧、樱桃视频的大片、茄子视频的悬疑、糖心视频的动漫——玫瑰视频一键聚合。',
    img: 'https://readdy.ai/api/search-image?query=Single%20unified%20portal%20concept%20with%20multiple%20content%20streams%20converging%20into%20one%20sleek%20interface%2C%20minimalist%20dark%20theme%2C%20geometric%20data%20flow%20visualization%2C%20clean%20professional%20design&width=600&height=400&seq=cards-03&orientation=landscape',
  },
  {
    title: '杜比音效+4K画质双重体验',
    desc: '精选片源支持杜比全景声和4K超高清画质输出，搭配大屏设备观看效果更震撼。我们持续引入高品质编码片源，打造影院级家庭观影感受。',
    img: 'https://readdy.ai/api/search-image?query=Premium%20home%20theater%20setup%20with%20large%20screen%20displaying%20vibrant%20cinematic%20image%2C%20sound%20system%20speakers%2C%20dim%20ambient%20lighting%2C%20luxury%20interior%2C%20warm%20color%20palette&width=600&height=400&seq=cards-04&orientation=landscape',
  },
  {
    title: '发现冷门佳作的新大陆',
    desc: '除了热门大片和爆款剧集，玫瑰视频也收录了大量独立电影、艺术短片和冷门经典。这里可能是你发现下一部人生电影的起点。',
    img: 'https://readdy.ai/api/search-image?query=Hidden%20gem%20discovery%20concept%20with%20vintage%20film%20reels%20and%20classic%20movie%20posters%20on%20a%20warm%20wooden%20desk%2C%20soft%20vintage%20lighting%2C%20nostalgic%20cinema%20atmosphere%2C%20art%20house%20film%20aesthetic&width=600&height=400&seq=cards-05&orientation=landscape',
  },
  {
    title: '守护优质内容的未来',
    desc: '玫瑰视频严格遵循正版合作原则，与各内容平台保持良好协作关系。我们致力于为用户提供安全、合法、高品质的观影环境。',
    img: 'https://readdy.ai/api/search-image?query=Professional%20media%20partnership%20concept%20with%20handshake%20silhouette%20against%20warm%20golden%20backlight%2C%20clean%20corporate%20aesthetic%2C%20trust%20and%20collaboration%20visual%2C%20soft%20focus%20background&width=600&height=400&seq=cards-06&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center">
          精选推荐
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          发现玫瑰视频的更多精彩亮点
        </p>

        <div className="mt-8 md:mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardsData.map((card, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer group"
            >
              <div className="h-44 md:h-48 overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base font-heading font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">
                  {card.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-3">
                  {card.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}